import { Component, computed, effect, input, output, signal } from '@angular/core';
import { FormControl } from '@angular/forms';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheck, faCopy, faSquareMinus, faSquarePlus, faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';

import { UiAdminModule } from '@eiq/ui';

import { TranslationRow } from '../../../models/translations/translation-row.model';

@Component({
  standalone: true,
  selector: 'empathy-translation-entry',
  templateUrl: 'translation-entry.component.html',
  styleUrls: ['translation-entry.component.scss'],
  imports: [FontAwesomeModule, UiAdminModule]
})
export class TranslationEntryComponent {
  row = input.required<TranslationRow>();
  showIgnoreButton = input(true);
  showIgnoreButtonOnHover = input(false);

  entryChange = output<string>();
  ignoreEntry = output<boolean>();
  inputFocused = output<void>();

  isEditing$ = signal(false);
  isCopied$ = signal(false);

  defaultHasValue$ = computed(() => !!this.row().defaultEntry.value?.trim());
  editorId$ = computed(() => this.row().translatedEntry.key.replace(/\./g, '_'));

  canEdit$ = computed(() => !this.row().translatedEntry.ignoredInd && (this.defaultHasValue$() || !!this.row().translatedEntry.value));

  translatedValueCtrl = new FormControl('', { nonNullable: true });

  faTriangleExclamation = faTriangleExclamation;
  faSquareMinus = faSquareMinus;
  faSquarePlus = faSquarePlus;
  faCopy = faCopy;
  faCheck = faCheck;

  constructor() {
    effect(() => {
      if (this.isEditing$()) {
        return;
      }

      const value = this.row().translatedEntry.value ?? '';
      this.translatedValueCtrl.setValue(value, { emitEvent: false });
    });

    this.translatedValueCtrl.valueChanges.subscribe((value) => this.entryChange.emit(value));
  }

  async onCopy(): Promise<void> {
    const html = this.row().defaultEntry.value ?? '';
    const plainText = new DOMParser().parseFromString(html, 'text/html').body.textContent ?? '';

    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/html': new Blob([html], { type: 'text/html' }),
          'text/plain': new Blob([plainText], { type: 'text/plain' })
        })
      ]);
    } catch {
      await navigator.clipboard.writeText(plainText);
    }

    this.isCopied$.set(true);
    setTimeout(() => this.isCopied$.set(false), 2000);
  }
}
